"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * German language bundle module.
 *
 * @module module:locale/languages/de
 * @see module:locale/languages/bundle
 *
 */

/** The language bundle. */
var _default = {
  $: {
    code: 'de',
    name: 'German'
  },
  keyboard: {
    // the localization keys are meaningful in react-simple-keyboard
    '{bksp}': '⇐',
    // tunnel compatibility (Win 7 kiosk)
    '{lock}': '⇪',
    // Apple German Keyboard
    '{shift}': '⇧',
    // Apple German Keyboard
    '{tab}': 'Weiter'
  }
};
exports["default"] = _default;